import React from 'react';
import { useLocation } from 'react-router-dom';
import { Typography } from '@naf-simba/building-blocks-typography';
import { useResolvedNavigationLink } from '../../../hooks/useResolvedNavigationLink';
import { NavigationBarItem } from '../../../../../types/globalSettingsType';
import { useHandleNavigationClick } from '../../../utils/Tracking/Navigation/NavigationTracking';
import * as S from './MobileMenuLink.styles';

interface MobileMenuLinkProps {
  item?: NavigationBarItem | null;
  menuSectionName?: string;
  mobileMenuGroup?: string;
}

export const MobileMenuLink = ({ item, menuSectionName, mobileMenuGroup }: MobileMenuLinkProps) => {
  const location = useLocation();
  const { url, blank } = useResolvedNavigationLink({
    data: item?.link?.data,
    type: item?.link?.type,
  });

  const handleOnClick = useHandleNavigationClick({
    event: 'mobileMenuClick',
    menuPage: location.pathname,
    menuSectionName,
    mobileMenuGroup,
    menuItemName: item?.header ?? '',
    menuItemUrl: url,
  });

  if (!item?.header || !url) return null;

  return (
    <S.LinkItem url={url} blank={blank} onClick={handleOnClick}>
      <Typography variant="paragraphM">{item.header}</Typography>
    </S.LinkItem>
  );
};
